import React from 'react';

// Packages
import { BrowserRouter as  Router, Routes, Route, Navigate  } from 'react-router-dom';
import { ConfigProvider, Layout, message } from 'antd';

// Components
import Header from './components/main/Header';
import Footer from './components/main/Footer';
import Authentication from './components/main/Authentication';
import PrivateRoute from './router/PrivateRoute';
import AdminRoute from './router/AdminRoute';
import OrgRoutes from './components/routes/OrgRoutes';
import Locations from './components/locations/Locations';
import Loads from './components/load/loads/Loads';
import LoadFiles from './components/load/files/LoadFiles';
import LoadStatus from './components/load/status/LoadStatus';
import LoadFileInfo from './components/load/files/LoadFileInfo';
import Errors from './components/self/errors/Errors';
import Schemas from './components/self/schemas/Schemas';
import Rules from './components/self/rules/Rules';
import Configurations from './components/self/configurations/Configurations';
import Cycles from './components/cycles/Cycles';
import LoadInfo from './components/load/loads/LoadInfo';
import Staffs from './components/users/staffs/Staffs';
import Settings from './components/self/settings/Settings';

// Wizard Components
import WizardStart from './components/wizard/WizardStart';
import WizardSchemas from './components/wizard/WizardSchemas';
import WizardCycles from './components/wizard/WizardCycles';
import WizardUpload from './components/wizard/WizardUpload';
import WizardStatus from './components/wizard/WizardStatus';

// Redux
import { Provider } from 'react-redux';
import store from './store';

// Actions
import { user_token_check } from './redux/actions/authActions';

user_token_check (store);

const App = () => {
	const [messageApi, contextHolder] = message.useMessage();

	return (
		<ConfigProvider
			theme={{
				token: {
					colorPrimary: '#3e619b',
					colorPrimaryBg: 'white'
				},
				components: {
					Table: {
						rowSelectedBg: '#C0C7CD'
					}
				}
			}}
		>
			<Provider store= { store }>
				<Router>
					<Layout>
						{contextHolder}

						<Header />

						<Layout.Content className='content'>
							<Routes>
								<Route path='/auth' element={ <Authentication /> } exact />

								<Route element={ <PrivateRoute /> } exact>
									{/* Load - Available to all authenticated users */}
									<Route path='/load/:load_id/files' element={ <LoadInfo messageApi={messageApi} /> } exact />
									<Route path='/loads' element={ <Loads messageApi={messageApi} /> } exact />
									<Route path='/load-files' element={ <LoadFiles messageApi={messageApi} /> } exact />
									<Route path='/load-status' element={ <LoadStatus messageApi={messageApi} /> } exact />
									<Route path='/load-file/:file_id/info' element={ <LoadFileInfo messageApi={messageApi} /> } exact />

									{/* Wizard Routes - Available to all authenticated users */}
									<Route path='/wizard/start' element={ <WizardStart /> } exact />
									<Route path='/wizard/schemas' element={ <WizardSchemas /> } exact />
									<Route path='/wizard/cycles' element={ <WizardCycles /> } exact />
									<Route path='/wizard/upload' element={ <WizardUpload /> } exact />
									<Route path='/wizard/status' element={ <WizardStatus /> } exact />
									<Route path='/wizard/status/*' element={ <WizardStatus /> } />

									{/* Cycles - Available to all authenticated users */}
									<Route path='/cycles' element={ <Cycles messageApi={messageApi} /> } exact />

									{/* Staffs - Available to all authenticated users */}
									<Route path='/staffs' element={ <Staffs messageApi={messageApi} /> } exact />
								</Route>

								<Route element={ <AdminRoute /> } exact>
									{/* Routes - Admin only */}
									<Route path='/routes' element={ <OrgRoutes messageApi={messageApi} /> } exact />

									{/* Locations - Admin only */}
									<Route path='/route/:route_id/locations' element={ <Locations messageApi={messageApi} /> } exact />

									{/* Errors - Admin only */}
									<Route path='/errors' element={ <Errors messageApi={messageApi} /> } exact />

									{/* Schemas - Admin only */}
									<Route path='/schemas' element={ <Schemas messageApi={messageApi} /> } exact />

									{/* Rules - Admin only */}
									<Route path='/rules' element={ <Rules messageApi={messageApi} /> } exact />

									{/* Configurations - Admin only */}
									<Route path='/configurations' element={ <Configurations messageApi={messageApi} /> } exact />

									{/* Setting - Admin only */}
									<Route path='/settings' element={ <Settings messageApi={messageApi} /> } exact />
								</Route>

								{/* Other */}
								<Route path='/wizard' element={ <Navigate to='/wizard/start' replace /> } />
								<Route path='/' element={ <Navigate to='/wizard/start' replace /> } />
								<Route path='*' element={ <Navigate to='/wizard/start' replace /> } />
							</Routes>
						</Layout.Content>

						<Footer/>
					</Layout>
				</Router>
			</Provider>
		</ConfigProvider>
	);
}

export default App;
